<template>
  <section>
    <inventory-supplemental-cost-component v-if="inventory"
      :key="inventory.id"
      :isCollapsed="false"
      v-model="inventory.supplementalCosts"
      :restoreByDefault="true"
      :selectedMakeModel="selectedMakeModel"
      :selectedTypeStatus="selectedTypeStatus"
      :selectedDispositionIntentionStatus="selectedDispositionIntentionStatus"
      :isHidden="true"
      :selectedInventoryId="inventory.id">
    </inventory-supplemental-cost-component>
  </section>
</template>

<script>

import InventorySupplementalCostComponent from '@/components/generic/inventory/InventorySupplementalCostComponent'
import { createNamespacedHelpers } from 'vuex'
const mapVehicleMakeGetters = createNamespacedHelpers('vehicleMake').mapGetters
const mapConfigGetters = createNamespacedHelpers('config').mapGetters

export default {
  name: 'RestoreInventoryDefaultCostsComponent',
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      inventory: this.value
    }
  },
  components: {
    'inventory-supplemental-cost-component': InventorySupplementalCostComponent
  },
  computed: {
    ...mapVehicleMakeGetters(['allVehicleMakes']),
    ...mapConfigGetters(['definedTypes']),
    selectedMakeModel: function () {
      if (!this.inventory) return null
      let make = this.getMake(this.inventory.vehicleMakeId)
      let model = this.getModel(make, this.inventory.vehicleMakeVersionId)
      let makeModel = {
        makeId: make ? make.id : 0,
        selectedMake: make,
        modelId: model ? model.id : 0,
        selectedModel: model
      }
      return makeModel
    },
    selectedTypeStatus: function () {
      if (!this.inventory) return null
      let typeStatus = this.getTypeStatus(this.inventory.type)
      return typeStatus
    },
    selectedDispositionIntentionStatus: function () {
      if (!this.inventory) return null
      let dispositionIntentionStatus = this.getDispositionIntentionStatus(this.inventory.dispositionIntention)
      return dispositionIntentionStatus
    }
  },
  methods: {
    getMake: function (vehicleMakeId) {
      let selectedMake = vehicleMakeId > 0 ? this.allVehicleMakes.find((x) => x.id === vehicleMakeId) : null
      return selectedMake
    },
    getModel: function (selectedMake, vehicleMakeVersionId) {
      let selectedModel = selectedMake && selectedMake.versions ? (selectedMake.versions.find((x) => x.id === vehicleMakeVersionId)) : null
      return selectedModel
    },
    getTypeStatus: function (type) {
      let typeStatus = this.definedTypes.inventoryTypes.find((x) => (x.name === type || x.altName === type))
      return typeStatus
    },
    getDispositionIntentionStatus: function (dispositionIntention) {
      let derivedDispostionIntention = dispositionIntention
 
      // If dispositionIntention not set on Inventory, lets make it retail
      if (derivedDispostionIntention === '')
        derivedDispostionIntention = 'Retail'

      let dispositionIntentionStatus = this.definedTypes.dispositionIntentionStatuses.find((x) => (x.name === derivedDispostionIntention || x.altName === derivedDispostionIntention))
      return dispositionIntentionStatus
    }
  },
  mounted: function () {
  }
}

</script>

<style scoped>

</style>
